import { useDispatch, useSelector } from "react-redux";
import { pusher } from "@common/services/socketCommution";
import { reducerPaths } from "../../../../../app/reducerPaths";
import { setLiveAuctionMultipleFields } from "../../../../../toolkit/liveAuction/liveAuctionSlice";
import React from "react";

const useCarsInNegotiationSocketEvents = ({
  sellerId,
  dealerId,
  Vehicle_Id,
  myCarsOrOtherCars,
  onNewCounterOfferHandler,
  onBidAcceptedHandler,
  onBidDeclinedHandler
}) => {

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  // useSelector start...
  const carsInNegotiation = useSelector(store => store[reducerPaths.carsInNegotiation]);
  const auth = useSelector(store => store[reducerPaths.auth]);
  // useSelector end...

  // Handlers start...
  const onBidAcceptedListener = (e) => {
    console.log(`onBidAcceptedListener`, e);
    if (onBidAcceptedHandler) {
      onBidAcceptedHandler(e);
    }
    // if (onNewBidHandler) {
    //   onNewBidHandler();
    // }
    // let newBidHistory = [
    //   {
    //     ...(e || {}),
    //     amount: e?.bidAmount,
    //     sellerId: e?.sellerId,
    //     Vehicle_Id: e?.vehicleId,
    //   },
    //   ...(liveAuction?.bidHistory?.data || []),
    // ];

    // console.log(newBidHistory, liveAuction?.bidHistory?.data, `newBidHistory`);
    // dispatch(
    //   setLiveAuctionMultipleFields({
    //     bidHistory: {
    //       ...liveAuction?.bidHistory,
    //       data: newBidHistory
    //     }
    //   })
    // )
  };

  const onBidDeclinedListener = (e) => {
    console.log(`onBidDeclinedListener`, e);
    if (onBidDeclinedHandler) {
      onBidDeclinedHandler(e);
    }
  };

  const onCounterOfferSentListener = (e) => {
    console.log(`onCounterOfferSentListener`, e);
    if (onNewCounterOfferHandler) {
      onNewCounterOfferHandler(e);
    }
  };
  // Handlers end...


  // useEffect start...
  React.useEffect(() => {
    let sellerChannel;
    let dealerChannel;
    let privateBidDeclinedChannel;
    let counterOfferSellerIdChannel;
    let counterOfferDealerIdChannel;
    if (myCarsOrOtherCars === 0) {
      if (sellerId) {
        sellerChannel = pusher.subscribe(`seller.${sellerId}`);
        sellerChannel.bind(`App\\Events\\BidAcceptedSeller`, onBidAcceptedListener);
      }
    } else {
      if (auth?.user_id) {
        dealerChannel = pusher.subscribe(`dealer.${auth?.user_id}`);
        dealerChannel.bind(`App\\Events\\BidAccepted`, onBidAcceptedListener);
      }
    }
    
    if (sellerId) {
      counterOfferSellerIdChannel = pusher.subscribe(`dealer-counter.${sellerId}`);
      counterOfferSellerIdChannel.bind(`counter-offer.sent`, onCounterOfferSentListener);
    }

    if (Vehicle_Id) { 
      privateBidDeclinedChannel = pusher.subscribe(`bid.declined.${Vehicle_Id}`);
      privateBidDeclinedChannel.bind(`App\\Events\\BidDeclined`, onBidDeclinedListener);
    }

    if (dealerId) {
      counterOfferDealerIdChannel = pusher.subscribe(`dealer-counter.${dealerId}`);
      counterOfferDealerIdChannel.bind(`counter-offer.sent`, onCounterOfferSentListener);
    }


    return () => {
      if (myCarsOrOtherCars === 0) {
        sellerChannel.unbind(`App\\Events\\BidAcceptedSeller`, onBidAcceptedListener);
      } else {
        dealerChannel.unbind(`App\\Events\\BidAccepted`, onBidAcceptedListener);
      }

      if (privateBidDeclinedChannel)
        privateBidDeclinedChannel.unbind(`App\\Events\\BidDeclined`, onBidDeclinedListener);
    
      if (counterOfferSellerIdChannel)
        counterOfferSellerIdChannel.unbind(`counter-offer.sent`, onCounterOfferSentListener);

      if (counterOfferDealerIdChannel)
        counterOfferDealerIdChannel.bind(`counter-offer.sent`, onCounterOfferSentListener);
    }
  }, [auth?.user_id, sellerId, dealerId, myCarsOrOtherCars, Vehicle_Id]);
  // useEffect end...

};  

export {
  useCarsInNegotiationSocketEvents
};